<template>
	<div class="w-100">
		<div id="personal"></div>
		<div class="position-relative z-index-1028">
      <div class="row no-gutters justify-content-center">
        <div class="fixed-top d-block nav-bottom">
          <div class="custom-container-fluid px-0">
            <div class="row justify-content-center no-gutters">
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                <div class="bg-white" :class="{'box-shadow-nav':scrollPosition > 50}">
                  <div class="container px-4 w-100 pt-1 pb-2">
                    <div class="row no-gutters py-2 m-0 w-100">
                      <div class="col-1">
                        <router-link :to="'/'+getMerchant().code+'/concierge/account'">
                          <img src="../../../../assets/img/icon/back-arrow.png" class="mt-1 cursor-pointer" width="15">
                        </router-link>
                      </div>
                      <div class="col-8">
                        <div class="">
                          <p class="mb-0 body-1-2 nav-hotel ml-3 mt-1">{{$t('hotel.menu.personal-data')}}</p>
                        </div>
                      </div>
                      <!-- <div class="col-3 text-right">
                        <p class="mb-0 body-2-2 font-bold text-green mt-2 cursor-pointer text-16" v-if="!is_edit" @click="toggleEdit(true)">Edit</p>
                        <p class="mb-0 body-2-2 font-bold text-green mt-2 cursor-pointer text-16" v-else @click="toggleEdit(false)">Simpan</p>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 60px"></div>
    <div class="container px-4 pt-4">
      <!-- <p class="mb-0 body-1-1 text-26">Personal Data</p>
      <p class="mb-4 body-3-3-1">Informasi mengenai data diri Anda.</p> -->
      <div class="row my-3 slim-grid-row text-center pb-1">
        <div class="col-12 align-self-center">
          <div class="d-inline-block align-middle">
            <div class="border-profil border-2-green bg-white rounded-50 mx-auto mb-0 cursor-pointer" @click="show_detail_photo = true">
              <img :src="avatar" class="rounded-50 img-profil d-block m-auto">
            </div>
          </div>
        </div>
        <div class="col-12 my-2">
          <label for="file_image">
            <div class="bg-light-page d-inline-block pt-1 pb-2 px-3 rounded border cursor-pointer">
              <img src="../../../../assets/img/icon/ar-camera-light.png" width="20" class="d-inline-block">
              <label for="file_image" class="mb-0 d-inline-block color-light cursor-pointer body-2-2 font-bold text-14 ml-1">{{$t('hotel.action.change-photo')}}</label>
              <input :disabled="push_loading" type="file" @change="handleFileChange($event)" accept="image/png, image/jpeg, image/jpg" id="file_image" class="d-none" />
            </div>
          </label>
        </div>
      </div>
      <div class="pb-2 mb-3 border-bottom">
        <p class="mb-1 body-2 text-14 font-regular">{{$t('hotel.concierge.full-name')}}</p>
        <p class="mb-0 body-2-2 text-16 font-semibold">{{getCurrentUser().first_name+''+ (getCurrentUser().last_name != null ? getCurrentUser().last_name : '')}}</p>
      </div>
      <div class="pb-2 mb-3 border-bottom">
        <p class="mb-1 body-2 text-14 font-regular">{{$t('hotel.concierge.email')}}</p>
        <p class="mb-0 body-2-2 text-16 font-semibold">{{getCurrentUser().email}}</p>
      </div>
      <div class="pb-2 mb-3 border-bottom">
        <p class="mb-1 body-2 text-14 font-regular">{{$t('hotel.concierge.phone-number')}}</p>
        <p class="mb-0 body-2-2 text-16 font-semibold">{{getCurrentUser().phone}}</p>
      </div>
      <!-- <div class="pb-2 mb-3 border-bottom">
        <p class="mb-1 body-2 text-14 font-regular">Country</p>
        <p class="mb-0 body-2-2 text-16 font-semibold">{{getCurrentUser().}}</p>
      </div> -->
      <!-- <div class="pb-2 mb-3 border-bottom">
        <p class="mb-1 body-2 text-14 font-regular">Address</p>
        <p class="mb-0 body-2-2 text-16 font-semibold">Jln. Luxville A Batu</p>
      </div> -->
    </div>
    <div class="fixed-bottom d-block nav-bottom" style="bottom: 0;">
      <div class="custom-container-fluid px-0">
        <div class="row justify-content-center no-gutters">
          <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
            <div class="my-3 container px-4" v-if="avatar_file != null">
              <div class="row no-gutters">
                <div class="col-12 mb-3" v-if="push_error">
                  <div class="p-3 border mb-3 radius-0 text-center" style="background-color: rgb(255, 243, 243); border-color: rgb(254, 184, 184) !important;">
                    <p class="mb-0 body-3-1">{{push_error}}</p>
                  </div>
                </div>
                <div class="col-6">
                  <div class="w-100 pr-2">
                    <button :disabled="push_loading" type="button" @click="cancelSubmit" class="button-black w-100">{{$t('hotel.action.cancel')}}</button>
                  </div>
                </div>
                <div class="col-6">
                  <div class="w-100 pl-2">
                    <button :disabled="push_loading" type="button" @click="submitAvatar" class="button-primary w-100" :class="{'cursor-disable':push_loading}">
                      <pulse-loader :loading="push_loading" v-if="push_loading"></pulse-loader>
                      <template v-else>{{$t('hotel.action.save-changes')}}</template>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Detail Photo Profile-->
    <transition name="fade">
      <template v-if="show_detail_photo">
        <div class="position-relative z-index-1045">
          <div class="row no-gutters justify-content-center">
            <div class="position-fixed w-100 d-block nav-bottom" style="top: 16%">
              <div class="custom-container-fluid px-0">
                <div class="row justify-content-center no-gutters">
                  <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                    <div class="bg-white rounded-top-3">
                      <div class="w-100">
                        <img src="../../../../assets/img/icon/cancel.png" class="d-inline-block p-2 rounded-3 bg-back mt-3 mx-3 cursor-pointer position-absolute" width="33" style="z-index: 1049;right: 0" @click="show_detail_photo = false">
                        <div class="w-100">
                          <img :src="avatar" class="d-block m-auto w-100">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </transition>
    <!-- BG Pop Up -->
    <template v-if="show_detail_photo">
      <transition name="fade">
        <div class="position-relative z-index-1038">
          <div class="row no-gutters justify-content-center">
            <div class="fixed-bottom d-block nav-bottom" style="bottom:0%">
              <div class="custom-container-fluid px-0">
                <div class="row justify-content-center no-gutters">
                  <div class="col-12 position-relative">
                    <div class="">
                      <div class="w-100 py-2 px-2" 
                        @click="show_detail_photo = false"
                        style="height: 100vh;background-color: #00000099">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </template>
  </div>
</template>
<script>
  import BottomNavbar from '@/components/hotel/BottomNavbar';
  import {mapGetters,mapActions} from "vuex";
  import {compressImage} from '@/utils/index.js';
  import {upload,get,post} from '@/services/index.js';

  export default{
    components:{
      BottomNavbar
    },
    metaInfo(){
      return {
        title: 'Personal Data',
        titleTemplate: this.getMetaTitleTemplate()
      }
    },
    data(){
      return{
        scrollPosition: null,
        show_detail_photo: false,
        avatar: null,
        avatar_file: null,
        push_loading: false,
        push_error: ''
      }
    },
    mounted() {
      window.addEventListener('scroll', this.updateScroll);
      document.getElementById('personal').scrollIntoView({
        behavior: 'smooth'
      });
    },
    created(){
      this.avatar = this.getCurrentUser().avatar
    },
    methods:{
      ...mapGetters(['getMerchant','getCurrentUser','getMetaTitleTemplate']),
      ...mapActions(['setUser']),
      updateScroll() {
          this.scrollPosition = window.scrollY
      },
      handleFileChange(evt){
        this.avatar_file = evt.target.files[0]
        this.avatar = URL.createObjectURL(evt.target.files[0])
      },
      toggleEdit(data){
        this.is_edit = data 
        document.getElementById('personal').scrollIntoView({
          behavior: 'smooth'
        });
      },
      toggleLabel(data, id){
        if (data == 'focus') {
          this.show_label[id] = true  
        }else{
          this.show_label[id] = (this.form[id] == '') ? false :  true 
        }
      },
      cancelSubmit(){
        this.avatar = this.getCurrentUser().avatar
        this.avatar_file = null
        this.push_loading = false
        this.push_error = ''
      },
      submitAvatar(){
        if(!this.push_loading){
          this.push_loading = true
          let self = this
          compressImage(this.avatar_file).then(response=>{
            if(response != false){
              let fd = new FormData();
              fd.append("image_file",response,response.name)
              post("BASE","auth/upload-avatar",fd).then(response=>{
                let res = response.data
                if (res.success) {
                  get("BASE","auth/profile").then(response_profile=>{
                    let res_profile = response_profile.data.user
                    this.setUser(res_profile)
                    this.push_loading = false
                    this.$router.push('/'+this.getMerchant().code+'/concierge/account')
                  })
                }else{
                  this.push_error = res.message
                  this.push_loading = false
                }
              })
            }else{
              this.push_error = this.$t('warning-message.compress-img.message')
              this.push_loading = false
            }
          })
        }
      }
    }
  }
</script>
<style scoped>
  .img-profil{
    width: 90px;
    height: 90px;
    object-fit: cover;
  }
  .border-profil{
    width: 100px;
    height: 100px;
    padding: 3px 0;
     border-radius: 100%!important;
  }
</style>


// WEBPACK FOOTER //
// src/pages/hotel/concierge/account/PersonalData.vue